import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { MadAuthService } from "../../mad-auth/mad-auth.service";
import { SubdomainService } from "../../_base/subdomain.service";
import { environment } from "src/environments/environment";
import { map } from "rxjs/operators";

@Injectable({
  providedIn: 'root'
})
export class PremiseOfValueAPIService {
  constructor(
    private http: HttpClient,
    private authService: MadAuthService,
    private subdomainService: SubdomainService
  ) {}

  fetchListing() {
    return this.http.get<{data: Array<{
      id: number,
      name: string
    }>}>(environment.baseApiUrl + `api/v2/${this.subdomainService.subDomain}/premises-of-value/listing`, {
      headers: this.authService.getAuthHeaders()
    }).pipe(
      map(response => response.data)
    )
  }
}